import { api } from './api';

export interface Snapshot {
  id: string;
  workspaceId: string;
  label: string;
  payload: unknown;
  createdAt: string;
  expiresAt: string | null;
}

export const snapshotsApi = {
  async list(workspaceId: string): Promise<Snapshot[]> {
    const r = await api.get<Snapshot[]>(`/api/workspaces/${workspaceId}/snapshots`);
    return r.data;
  },
  async create(workspaceId: string, body: { label?: string; ttlDays?: number }): Promise<Snapshot> {
    const r = await api.post<Snapshot>(`/api/workspaces/${workspaceId}/snapshots`, body);
    return r.data;
  },
  async getPublic(id: string): Promise<Snapshot> {
    const r = await api.get<Snapshot>(`/api/snapshots/${id}`);
    return r.data;
  },
  /** Revoke a share link. */
  async remove(id: string): Promise<void> {
    await api.delete(`/api/snapshots/${id}`);
  },
  publicUrl(id: string): string {
    return `${window.location.origin}/share/${id}`;
  },
};
